import { FinancialWorkspaceValueObjectsCostTypeEnum } from 'generated/resources/graphql'

import { useInsightTableItems } from 'modules/finance/components/FinancialWorkspace/hooks/useInsightTableItems'
import { InsightTableGroupBy } from 'modules/finance/components/FinancialWorkspace/types/table'
import { TableDataVariables } from 'modules/finance/components/FinancialWorkspace/types/table'

export interface EvolutionChartProps {
  variables: TableDataVariables
  limit?: number
  skip?: boolean
  costType?: FinancialWorkspaceValueObjectsCostTypeEnum
}

const formatVariables = (
  variables: TableDataVariables,
  costType?: FinancialWorkspaceValueObjectsCostTypeEnum
) => {
  // remove pagination options and unused common variables
  // eslint-disable-next-line unused-imports/no-unused-vars
  const { offset, itemsPerPage, formattedCompareToEndDate, formattedCompareToStartDate, ...rest } =
    variables

  return {
    resourceFilter: {
      ...rest,
      costType,
      groupBy: InsightTableGroupBy.LineItem,
    },
  }
}

export const useEvolutionChartData = ({
  variables,
  limit,
  skip,
  costType,
}: EvolutionChartProps) => {
  const { resourceFilter } = formatVariables(variables, costType)

  const result = useInsightTableItems(
    {
      resourceFilter,
      itemsPerPage: limit,
    },
    skip
  )

  return result
}
